"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.сacheSettings = void 0;
exports.сacheSettings = {
    TokenList: {
        timeToLive: 1000 * 60 * 60 * 12,
    },
};
